class Session {
  set(key: string, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string) {
    const val = localStorage.getItem(key);
    return JSON.parse(val);
  }

  remove(key: string) {
    return localStorage.removeItem(key);
  }
}

const LocalStorage = new Session();

export { LocalStorage };
